// Admin routes for P7-D (CUSTOMER-03…06, segments). Owned by that worker; the router mounts whatever
// this returns under the app shell (before the store-area placeholder), so modules never edit
// router.tsx. Paths follow IA §2.1 under Customers. The customer page panels (consent, suppressions,
// privacy requests) live in customers/CustomersPage.tsx (CustomerDetailPage, commerce module route).
// Static segments (`segments`, `suppressions`) outrank the `$customerId` param in TanStack Router.
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../customers/SegmentsPage");
const SegmentDetailPage = lazyRouteComponent(load1, "SegmentDetailPage");
const SegmentsPage = lazyRouteComponent(load1, "SegmentsPage");
const load2 = () => import("../customers/SuppressionsPage");
const SuppressionsPage = lazyRouteComponent(load2, "SuppressionsPage");

export function engagementRoutes(appRoute: AnyRoute): AnyRoute[] {
  const r = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    r("/$org/$store/customers/suppressions", SuppressionsPage),
    r("/$org/$store/customers/segments", SegmentsPage),
    r("/$org/$store/customers/segments/$segmentId", SegmentDetailPage),
  ];
}
